"use strict";exports.fullWidthClassName="width-before-scroll-bar",exports.noScrollbarsClassName="with-scroll-bars-hidden",exports.removedBarSizeVariable="--removed-body-scroll-bar-size",exports.zeroRightClassName="right-scroll-bar-position";
//# sourceMappingURL=constants.js.map
